(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8764],{

/***/ 17280:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/billing/documents",
      function () {
        return __webpack_require__(8376);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15313);
/* harmony import */ var theme_sub_menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66084);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99408);





function TopNav(param) {
    var _activeKey = param.activeKey, activeKey = _activeKey === void 0 ? "panoramic" : _activeKey;
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(theme_sub_menu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        activeKey: activeKey,
        languageCode: languageCode,
        options: [
            {
                key: "panoramic",
                title: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode].panoramic,
                href: "/billing"
            },
            {
                key: "profiles",
                title: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode].profiles,
                href: "/billing/profiles"
            },
            {
                key: "documents",
                title: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode].documents,
                href: "/billing/documents"
            },
            {
                key: "reports",
                title: translations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[languageCode].reports,
                href: "/billing/reports"
            }, 
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (TopNav);


/***/ }),

/***/ 32095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15313);
/* harmony import */ var redux_api_reselect_profile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95293);




function TopBar() {
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    var customerType = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_api_reselect_profile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).customerType;
    return languageCode === "REMOVED" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "sl-top-bar",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "sl-top-bar-container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "sl-top-bar-content",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "Su Ready sconto del 20% su tutti i servizi editoriali, approfittane subito! Promo valida fino a venerd\xec 18 novembre 2022"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "sl-top-bar-actions",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://readybooks.io",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "Vai su Ready"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (TopBar);


/***/ }),

/***/ 42805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ warning_notification; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./src/redux/action/warning.js
var warning = __webpack_require__(6482);
// EXTERNAL MODULE: ./src/redux/reselect/profile.js
var profile = __webpack_require__(95293);
// EXTERNAL MODULE: ./src/redux/reselect/warning.js
var reselect_warning = __webpack_require__(97998);
// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
// EXTERNAL MODULE: ./src/theme/icons/alert.js
var icons_alert = __webpack_require__(88176);
;// CONCATENATED MODULE: ./src/theme/icons/hide.js


function Hide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.05475 7.50925L2.159 4.6135C1.019 5.85625 0.587 7.10125 0.5795 7.12675L0.5 7.36375L0.57875 7.60075C0.59525 7.651 2.31575 12.6137 8.0405 12.6137C8.73725 12.6137 9.37175 12.5372 9.9545 12.409L7.895 10.3495C7.15346 10.3131 6.45196 10.0022 5.92699 9.47726C5.40201 8.95228 5.0911 8.25078 5.05475 7.50925ZM8.0405 2.11375C6.64925 2.11375 5.50925 2.41675 4.559 2.86225L1.78025 0.0834961L0.71975 1.144L14.2197 14.644L15.2803 13.5835L12.8068 11.11C14.7853 9.64525 15.491 7.63225 15.5015 7.60075L15.5802 7.36375L15.5015 7.12675C15.485 7.0765 13.7653 2.11375 8.0405 2.11375ZM9.47 7.77324C9.61025 7.26549 9.491 6.694 9.101 6.30325C8.711 5.9125 8.13875 5.794 7.631 5.93425L6.5 4.80325C6.96347 4.51823 7.49641 4.36619 8.0405 4.36375C9.695 4.36375 11.0405 5.70925 11.0405 7.36375C11.0383 7.90773 10.8859 8.44055 10.6003 8.9035L9.47 7.77324Z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ var hide = (Hide);

// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/components/warning-notification/index.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: ",
        ";\n  width: 100%;\n  border-radius: 12px;\n\n  & > .head {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    & > div {\n      display: flex;\n      flex-direction: row;\n    }\n\n    & > div > span {\n      color: ",
        ";\n    }\n  }\n\n  & > .notification {\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    background: ",
        ";\n    border-left: 4px solid ",
        ";\n    padding: ",
        "px;\n    margin: ",
        "px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4ef63db-0"
})(_templateObject(), index_esm/* space */.Dh, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "block" : "none";
}, (0,dist_index_esm/* themeGet */.R)("colors.warning"), (0,dist_index_esm/* themeGet */.R)("colors.accent"), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("colors.warning"), (0,dist_index_esm/* themeGet */.R)("space.xs"), (0,dist_index_esm/* themeGet */.R)("space.xs"));
function WarningNotification(param) {
    var style = param.style, className = param.className;
    var dispatch = (0,es/* useDispatch */.I0)();
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var isVisible = (0,es/* useSelector */.v9)(function(state) {
        return state.warning;
    }).isVisible;
    var warnings = (0,es/* useSelector */.v9)(reselect_warning/* default */.Z);
    (0,react.useEffect)(function() {
        dispatch((0,warning/* getWarningRequest */.jT)());
    }, [
        dispatch
    ]);
    var handleClose = (0,react.useCallback)(function() {
        dispatch((0,warning/* setWarningVisible */.Ic)(false));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isVisible: isVisible && warnings.length
    }, style), {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "head",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_alert/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h4",
                                lineHeight: "h4",
                                fontWeight: "bold",
                                color: "grey_600",
                                ml: "10px",
                                children: translations/* default */.Z[languageCode].warning
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: translations/* default */.Z[languageCode].warning,
                        type: "button",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hide, {})
                    })
                ]
            }),
            warnings.map(function(param) {
                var key = param.key, message = param.message;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "notification",
                    children: message
                }, key);
            })
        ]
    }));
}
/* harmony default export */ var warning_notification = (WarningNotification);


/***/ }),

/***/ 8376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ billing_documents; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./src/components/auth-switch/index.js + 15 modules
var auth_switch = __webpack_require__(17343);
// EXTERNAL MODULE: ./src/components/warning-notification/index.js + 1 modules
var warning_notification = __webpack_require__(42805);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/redux/action/taxDocuments.js
var taxDocuments = __webpack_require__(9193);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/redux/reselect/taxDocuments.js
/* eslint-disable camelcase */ 
/* harmony default export */ var reselect_taxDocuments = ((0,reselect_es/* createSelector */.P1)(function(state) {
    return state.taxDocuments.payload;
}, function(payload) {
    var data = payload.data, meta = payload.meta;
    if (!data || !data.length) {
        return {
            pageNumber: 1,
            perPage: 10,
            totalPages: 0,
            totalCount: 0,
            data: []
        };
    }
    var current = meta.pageNumber.current, perPage = meta.perPage, totalPages = meta.totalPages, totalCount = meta.totalCount;
    return {
        pageNumber: current,
        perPage: perPage,
        totalPages: totalPages,
        totalCount: totalCount,
        data: data.map(function(param) {
            var id = param.id, description = param.description, _attributes = param.attributes, name = _attributes.name, year = _attributes.year, downloadLink = param.links.downloadLink;
            return {
                key: id,
                id: id,
                name: name,
                year: year,
                downloadLink: downloadLink,
                description: description
            };
        })
    };
}));

// EXTERNAL MODULE: ./src/redux/reselect/profile.js
var profile = __webpack_require__(95293);
// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
// EXTERNAL MODULE: ./src/theme/table/default/index.js
var table_default = __webpack_require__(72544);
// EXTERNAL MODULE: ./src/theme/icons/filetype-pdf.js
var filetype_pdf = __webpack_require__(53845);
// EXTERNAL MODULE: ./src/theme/buttons/btn-link.js
var btn_link = __webpack_require__(25733);
// EXTERNAL MODULE: ./src/theme/icons/plus.js
var plus = __webpack_require__(26398);
// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
;// CONCATENATED MODULE: ./src/components/billing/documents/index.js
/* eslint-disable no-nested-ternary */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n\n  & > div {\n    width: 100%;\n    max-width: 2100px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: 12px;\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
















var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67ef4aee-0"
})(_templateObject(), index_esm/* space */.Dh);
var WrapTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67ef4aee-1"
})(_templateObject1(), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("colors.primary_100"));
var WrapPdfBtn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67ef4aee-2"
})(_templateObject2());
var Row = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67ef4aee-3"
})(_templateObject3(), index_esm/* flexbox */.GQ);
function DocumentsBilling() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var push = (0,router.useRouter)().push;
    var ref = (0,react.useState)(0), page = ref[0], setPage = ref[1];
    var ref1 = (0,react.useState)(10), pageSize = ref1[0], setPageSize = ref1[1];
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var isWaiting = (0,es/* useSelector */.v9)(function(state) {
        return state.taxDocuments;
    }).isWaiting;
    var payload = (0,es/* useSelector */.v9)(reselect_taxDocuments);
    var ref2 = (0,es/* useSelector */.v9)(profile/* default */.Z), company = ref2.payload.company;
    (0,react.useEffect)(function() {
        dispatch((0,taxDocuments/* getTaxDocumentsRequest */.jy)({
            page: page,
            pageSize: pageSize
        }));
    }, [
        dispatch,
        page,
        pageSize
    ]);
    var handleChangeSize = (0,react.useCallback)(function(current, s) {
        setPageSize(s);
    }, []);
    var handleChange = (0,react.useCallback)(function(param) {
        var _pagination = param.pagination, current = _pagination.current, ps = _pagination.pageSize;
        if (current && ps) {
            setPage((current - 1) * ps);
        }
    }, []);
    var handleDownloadPdf = (0,react.useCallback)(function(pid, path) {
        dispatch((0,taxDocuments/* downloadTaxDocumentRequest */.mW)({
            pid: pid,
            path: path
        }));
    }, [
        dispatch
    ]);
    var columns = (0,react.useMemo)(function() {
        return [
            {
                title: translations/* default */.Z[languageCode].Name,
                dataIndex: "name",
                key: "name",
                width: 200,
                render: function(name, row) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                children: name
                            }),
                            (row === null || row === void 0 ? void 0 : (ref = row.original) === null || ref === void 0 ? void 0 : ref.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "small",
                                fontWeight: "bold",
                                color: "grey_400",
                                children: row === null || row === void 0 ? void 0 : (ref1 = row.original) === null || ref1 === void 0 ? void 0 : ref1.description
                            })
                        ]
                    });
                }
            },
            {
                title: translations/* default */.Z[languageCode].Year,
                dataIndex: "year",
                key: "year",
                width: 50
            },
            {
                title: translations/* default */.Z[languageCode].Download,
                dataIndex: "downloadLink",
                key: "downloadLink",
                width: 50,
                render: function(link, row) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapPdfBtn, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: function() {
                                return handleDownloadPdf(row.id, link);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filetype_pdf/* default */.Z, {})
                        })
                    });
                }
            }, 
        ];
    }, [
        languageCode,
        handleDownloadPdf
    ]);
    var handleOnClickNew = (0,react.useCallback)(function() {
        return push("/billing/tax-interview");
    }, [
        push
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        px: "l",
        py: "xs",
        my: "xs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            fontSize: "h3",
                            lineHeight: "h3",
                            fontWeight: "bold",
                            color: "grey_600",
                            mt: "m",
                            mb: "s",
                            children: translations/* default */.Z[languageCode]["Your documents"]
                        }),
                        company && company.code === "SL_US" && /*#__PURE__*/ (0,jsx_runtime.jsx)(btn_link/* default */.Z, {
                            label: translations/* default */.Z[languageCode]["Create new"],
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(plus/* default */.Z, {}),
                            onClick: handleOnClickNew
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapTable, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(table_default/* default */.Z, {
                        emptyLabel: translations/* default */.Z[languageCode]["no available"],
                        columns: columns,
                        dataSource: payload.data,
                        pagination: {
                            showSizeChanger: true,
                            position: "bottomCenter",
                            pageSize: pageSize,
                            total: payload.totalCount,
                            onShowSizeChange: handleChangeSize
                        },
                        total: payload.totalCount || 0,
                        onChangeTable: handleChange,
                        loading: isWaiting,
                        languageCode: languageCode
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var documents = (DocumentsBilling);

// EXTERNAL MODULE: ./src/components/billing/top-nav.js
var top_nav = __webpack_require__(73097);
// EXTERNAL MODULE: ./src/theme/header/index.js + 1 modules
var header = __webpack_require__(28116);
// EXTERNAL MODULE: ./src/theme/layouts/body.js
var body = __webpack_require__(89129);
// EXTERNAL MODULE: ./src/components/top-bar/index.js
var top_bar = __webpack_require__(32095);
;// CONCATENATED MODULE: ./src/pages/billing/documents.js

function documents_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  min-width: 1024px;\n"
    ]);
    documents_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function documents_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px ",
        "px 0;\n"
    ]);
    documents_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var documents_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba84d49f-0"
})(documents_templateObject(), index_esm/* space */.Dh);
var StyledWarningNotification = (0,styled_components_browser_esm/* default */.ZP)(warning_notification/* default */.Z).withConfig({
    componentId: "sc-ba84d49f-1"
})(documents_templateObject1(), (0,dist_index_esm/* themeGet */.R)("space.l"), (0,dist_index_esm/* themeGet */.R)("space.l"));
function BillingPage() {
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(auth_switch/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(documents_Wrapper, {
                pb: "xxl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(body/* default */.Z, {
                        bg: "primary_50",
                        height: "100%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                        bg: "white",
                        title: translations/* default */.Z[languageCode]["Billing Tax Documents"],
                        style: {
                            bg: "white",
                            borderWidth: "0",
                            borderBottomWidth: "1px",
                            borderColor: "primary_200",
                            borderStyle: "solid"
                        },
                        componentLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                            ml: "l",
                            fontSize: "h2",
                            lineHeight: "h2",
                            fontWeight: "bold",
                            color: "grey_600",
                            textAlign: "left",
                            children: translations/* default */.Z[languageCode].billing
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(top_nav/* default */.Z, {
                        activeKey: "documents"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWarningNotification, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(documents, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var billing_documents = (BillingPage);


/***/ }),

/***/ 25733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50056);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14141);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 56px;\n  min-width: 140px;\n  background: transparent;\n  outline: 0;\n\n  & > span {\n    color: ",
        ";\n    border-radius: 12px;\n\n    padding: 0 ",
        "px;\n\n    width: 100%;\n    height: 100%;\n\n    ",
        "\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &:hover {\n      color: ",
        ";\n    }\n\n    &:focus {\n      color: ",
        ";\n    }\n\n    & > .icon-left {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-right: ",
        "px;\n    }\n  }\n\n  &:focus {\n    color: transparent;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Button = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-7a71ebf5-0"
})(_templateObject(), function(param) {
    var isFocused = param.isFocused;
    return isFocused ? (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_600") : (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_400");
}, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.s"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .typography */ .cp, (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_500"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("colors.primary_600"), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_4__/* .themeGet */ .R)("space.xs"), styled_system__WEBPACK_IMPORTED_MODULE_3__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_3__/* .layout */ .bK);
function BtnLink(param) {
    var style = param.style, title = param.title, label = param.label, type = param.type, onClick = param.onClick, disabled = param.disabled, isWaiting = param.isWaiting, icon = param.icon, fontSize = param.fontSize, lineHeight = param.lineHeight, fontWeight = param.fontWeight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        title: title || label,
        "aria-label": title || label,
        fontSize: fontSize || "h4",
        lineHeight: lineHeight || "h4",
        fontWeight: fontWeight || "bold"
    }, style), {
        type: type,
        disabled: disabled || isWaiting,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
            children: [
                icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: "icon-left",
                    children: icon
                }),
                label
            ]
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (BtnLink);


/***/ }),

/***/ 53845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function FiletypePdf() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.5 22.2676H7.5C6.70435 22.2676 5.94129 21.9515 5.37868 21.3889C4.81607 20.8263 4.5 20.0632 4.5 19.2676V5.26758C4.5 4.47193 4.81607 3.70887 5.37868 3.14626C5.94129 2.58365 6.70435 2.26758 7.5 2.26758H14.09C14.3523 2.26868 14.6037 2.37283 14.79 2.55758L19.21 6.97758C19.3947 7.16384 19.4989 7.41524 19.5 7.67758V19.2676C19.5 20.0632 19.1839 20.8263 18.6213 21.3889C18.0587 21.9515 17.2956 22.2676 16.5 22.2676Z",
                fill: "#F44336"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.8002 8.00766H15.2002C14.8024 8.00766 14.4208 7.84962 14.1395 7.56832C13.8582 7.28701 13.7002 6.90548 13.7002 6.50766V2.90766C13.6998 2.79856 13.7318 2.6918 13.7922 2.60095C13.8526 2.5101 13.9387 2.43927 14.0394 2.39746C14.1402 2.35565 14.2511 2.34475 14.3581 2.36616C14.4651 2.38756 14.5633 2.4403 14.6402 2.51766L19.1902 7.06766C19.2676 7.14459 19.3203 7.24278 19.3417 7.34976C19.3631 7.45674 19.3522 7.56766 19.3104 7.66843C19.2686 7.7692 19.1978 7.85526 19.1069 7.91567C19.0161 7.97607 18.9093 8.00809 18.8002 8.00766Z",
                fill: "#FF8A80"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.89016 19.3976C7.82085 19.4077 7.75015 19.4015 7.68368 19.3794C7.61721 19.3573 7.55681 19.32 7.50729 19.2705C7.45777 19.221 7.42049 19.1606 7.39842 19.0941C7.37635 19.0277 7.37009 18.957 7.38016 18.8876V15.9576C7.37044 15.8893 7.37659 15.8196 7.39813 15.754C7.41967 15.6884 7.45601 15.6286 7.50435 15.5793C7.55269 15.53 7.61173 15.4925 7.6769 15.4696C7.74207 15.4468 7.81162 15.4393 7.88016 15.4476C7.94167 15.4407 8.00394 15.4466 8.06308 15.4648C8.12223 15.483 8.17698 15.5133 8.2239 15.5536C8.27083 15.594 8.30893 15.6436 8.33582 15.6993C8.3627 15.7551 8.3778 15.8158 8.38016 15.8776C8.46079 15.7372 8.58311 15.6254 8.73016 15.5576C8.88759 15.476 9.06284 15.4348 9.24016 15.4376C9.46641 15.4345 9.68872 15.497 9.88016 15.6176C10.0688 15.7436 10.2179 15.9204 10.3102 16.1276C10.4161 16.3758 10.4707 16.6428 10.4707 16.9126C10.4707 17.1825 10.4161 17.4495 10.3102 17.6976C10.1738 17.9755 9.9354 18.1899 9.6447 18.2961C9.35401 18.4023 9.03351 18.3921 8.75016 18.2676C8.60837 18.2014 8.48735 18.0976 8.40016 17.9676V18.8776C8.40594 18.9465 8.39737 19.0159 8.37499 19.0813C8.35262 19.1467 8.31692 19.2067 8.27016 19.2576C8.2194 19.3052 8.15962 19.3421 8.09435 19.3662C8.02908 19.3902 7.95964 19.4009 7.89016 19.3976ZM8.89016 17.6376C8.96301 17.6384 9.03508 17.6227 9.10092 17.5915C9.16676 17.5603 9.22463 17.5145 9.27016 17.4576C9.38163 17.2972 9.43135 17.1019 9.41016 16.9076C9.43045 16.7135 9.38081 16.5185 9.27016 16.3576C9.22275 16.3037 9.16427 16.2605 9.09869 16.2312C9.03312 16.2019 8.96199 16.187 8.89016 16.1876C8.81675 16.1862 8.7439 16.2007 8.67659 16.23C8.60928 16.2594 8.5491 16.3029 8.50016 16.3576C8.39472 16.5208 8.34555 16.7139 8.36016 16.9076C8.34403 17.1015 8.39333 17.2951 8.50016 17.4576C8.54969 17.5202 8.61403 17.5694 8.68737 17.6008C8.7607 17.6323 8.84071 17.6449 8.92016 17.6376H8.89016Z",
                fill: "#FFEBEE"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.1699 18.3771C11.9476 18.3855 11.7279 18.3262 11.5399 18.2071C11.3483 18.0818 11.1959 17.905 11.0999 17.6971C10.994 17.4489 10.9395 17.1819 10.9395 16.9121C10.9395 16.6423 10.994 16.3753 11.0999 16.1271C11.1959 15.9192 11.3483 15.7424 11.5399 15.6171C11.7271 15.4951 11.9466 15.4323 12.1699 15.4371C12.3439 15.4354 12.5157 15.4767 12.6699 15.5571C12.8081 15.6198 12.9285 15.716 13.0199 15.8371V14.7471C13.0099 14.6778 13.0161 14.6071 13.0382 14.5406C13.0603 14.4741 13.0976 14.4137 13.1471 14.3642C13.1966 14.3147 13.257 14.2774 13.3235 14.2553C13.3899 14.2333 13.4606 14.227 13.5299 14.2371C13.5972 14.2321 13.6649 14.2411 13.7285 14.2635C13.7922 14.2858 13.8506 14.3211 13.8999 14.3671C13.9467 14.418 13.9824 14.4781 14.0048 14.5435C14.0272 14.6089 14.0357 14.6782 14.0299 14.7471V17.8571C14.0406 17.9897 13.9981 18.1211 13.9118 18.2224C13.8255 18.3236 13.7026 18.3865 13.5699 18.3971C13.5043 18.4023 13.4382 18.3946 13.3756 18.3743C13.3129 18.3541 13.2548 18.3216 13.2047 18.2789C13.1034 18.1927 13.0406 18.0697 13.0299 17.9371C12.953 18.0768 12.8341 18.1887 12.6899 18.2571C12.5286 18.3377 12.3503 18.3788 12.1699 18.3771ZM12.4999 17.6371C12.5728 17.6379 12.6449 17.6221 12.7107 17.5909C12.7765 17.5597 12.8344 17.514 12.8799 17.4571C12.9958 17.2984 13.0492 17.1026 13.0299 16.9071C13.0473 16.7117 12.9941 16.5166 12.8799 16.3571C12.8325 16.3031 12.7741 16.26 12.7085 16.2307C12.6429 16.2013 12.5718 16.1865 12.4999 16.1871C12.428 16.1858 12.3567 16.2004 12.291 16.2297C12.2253 16.2591 12.1669 16.3026 12.1199 16.3571C12.0058 16.5166 11.9526 16.7117 11.9699 16.9071C11.9507 17.1026 12.0041 17.2984 12.1199 17.4571C12.1644 17.5151 12.2221 17.5617 12.2882 17.5931C12.3543 17.6244 12.4269 17.6395 12.4999 17.6371Z",
                fill: "#FFEBEE"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.5202 18.3677C15.4513 18.3757 15.3814 18.368 15.3159 18.3452C15.2504 18.3224 15.1909 18.2851 15.1418 18.2361C15.0928 18.187 15.0554 18.1275 15.0326 18.062C15.0098 17.9965 15.0022 17.9266 15.0102 17.8577V16.2677H14.8602C14.8079 16.2759 14.7545 16.2719 14.7042 16.2558C14.6538 16.2398 14.6079 16.2123 14.57 16.1754C14.5322 16.1385 14.5034 16.0933 14.4861 16.0434C14.4688 15.9934 14.4633 15.9401 14.4702 15.8877C14.4702 15.6377 14.6002 15.5177 14.8602 15.5177H15.0002C14.9958 15.3573 15.0236 15.1977 15.082 15.0483C15.1404 14.8988 15.2282 14.7626 15.3402 14.6477C15.5982 14.4286 15.922 14.3019 16.2602 14.2877H16.4302C16.5232 14.2504 16.6271 14.2504 16.7202 14.2877C16.7876 14.3262 16.8404 14.386 16.8702 14.4577C16.885 14.5303 16.885 14.6051 16.8702 14.6777C16.8586 14.7483 16.8274 14.8141 16.7802 14.8677C16.7357 14.9235 16.671 14.9595 16.6002 14.9677H16.5202C16.374 14.9612 16.2297 15.0034 16.1102 15.0877C16.0714 15.129 16.0416 15.1779 16.0227 15.2312C16.0038 15.2846 15.9961 15.3413 16.0002 15.3977V15.4877H16.3202C16.5802 15.4877 16.7102 15.6077 16.7102 15.8577C16.717 15.9101 16.7116 15.9634 16.6942 16.0134C16.6769 16.0633 16.6482 16.1085 16.6103 16.1454C16.5725 16.1823 16.5265 16.2098 16.4762 16.2258C16.4258 16.2419 16.3724 16.2459 16.3202 16.2377H16.0002V17.8377C16.0127 17.9057 16.0094 17.9757 15.9905 18.0423C15.9716 18.1088 15.9376 18.1701 15.8912 18.2214C15.8447 18.2726 15.7871 18.3125 15.7228 18.3379C15.6584 18.3633 15.5891 18.3735 15.5202 18.3677Z",
                fill: "#FFEBEE"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FiletypePdf);


/***/ }),

/***/ 26398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Plus(param) {
    var width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width || "18",
        viewBox: "0 0 18 19",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16 10.2271H10V16.2271H8V10.2271H2V8.22705H8V2.22705H10V8.22705H16V10.2271Z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Plus);


/***/ }),

/***/ 66084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14141);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32016);
/* harmony import */ var _styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50056);
/* harmony import */ var theme_text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5799);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n\n  ",
        "\n\n  & > a {\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 8px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 2px;\n  height: 34px; /* Altezza adeguata per stare tra i bottoni */\n  background-color: ",
        ";\n  margin: 0 8px; /* Spazio tra gli elementi */\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c093c216-0"
})(_templateObject(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("colors.primary_200"), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space */ .Dh);
var TabBtn = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-c093c216-1"
})(_templateObject1(), styled_system__WEBPACK_IMPORTED_MODULE_4__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_4__/* .space */ .Dh);
var HorizontalDivider = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c093c216-2"
})(_templateObject2(), (0,_styled_system_theme_get__WEBPACK_IMPORTED_MODULE_5__/* .themeGet */ .R)("colors.primary_200"));
function SubMenu(param) {
    var activeKey = param.activeKey, options = param.options;
    var isConfirmed = options.length > 0 && options[1].key === "confirmed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        py: "s",
        px: "l",
        children: options.map(function(option, index) {
            var isSecondWithOnClick = index === 1 && option.onClick;
            var nextOptionExists = index < options.length - 1;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: [
                    !option.onClick ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: option.href,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            className: "link",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TabBtn, {
                                type: "button",
                                py: "s",
                                px: "m",
                                bg: activeKey === option.key ? "primary_100" : "transparent",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    fontSize: "h3",
                                    lineHeight: "h3",
                                    fontWeight: "medium",
                                    color: activeKey === option.key ? "primary_500" : option.color ? option.color : "grey_400",
                                    textAlign: "center",
                                    children: option.title
                                })
                            })
                        })
                    }, option.key) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TabBtn, {
                        type: "button",
                        py: "s",
                        px: "m",
                        bg: activeKey === option.key ? "primary_100" : (option === null || option === void 0 ? void 0 : option.bgColor) ? option === null || option === void 0 ? void 0 : option.bgColor : "transparent",
                        onClick: option.onClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_text__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            fontSize: "h3",
                            lineHeight: "h3",
                            fontWeight: "medium",
                            color: activeKey === option.key ? "primary_500" : (option === null || option === void 0 ? void 0 : option.color) ? option === null || option === void 0 ? void 0 : option.color : "grey_400",
                            textAlign: "center",
                            children: option.title
                        })
                    }),
                    isSecondWithOnClick && nextOptionExists && isConfirmed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HorizontalDivider, {})
                ]
            }, option.key);
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SubMenu);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3092,1664,8098,8446,4064,280,1354,9253,6535,7343,2544,9774,2888,179], function() { return __webpack_exec__(17280); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);